import { ChevronDownIcon } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

import { CheckIcon } from '../../icons/check-icon'
import { PinIcon } from '../../icons/pin-icon'

type DropdownLocationListItemProps = {
  description: string
  placeId: string
  isSelected: boolean
  onSelectItem: (placeId: string, description: string) => void
  subtitle: string
}

const DropdownLocationListItem = ({
  description,
  placeId,
  isSelected,
  onSelectItem,
  subtitle,
}: DropdownLocationListItemProps) => {
  return (
    <li
      className="group/location-list flex min-h-[60px] w-full cursor-pointer items-center justify-between rounded-[12px] px-3 transition-all duration-200 hover:bg-accent"
      onClick={() => {
        onSelectItem(placeId, description)
      }}
    >
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex size-[45px] min-w-[45px] items-center justify-center rounded-[8px] bg-accent text-primary group-hover/location-list:bg-white group-hover/location-list:text-primary',
            isSelected &&
              'bg-primary text-white group-hover/location-list:bg-primary group-hover/location-list:text-white',
          )}
        >
          <PinIcon size={20} />
        </div>
        <div className="flex flex-col">
          <span className="line-clamp-1 text-[15px] font-medium">{description}</span>
          <span className="line-clamp-1 text-[13px] font-normal text-muted">{subtitle}</span>
        </div>
      </div>
      {!isSelected && (
        <div className="flex min-w-[25px] items-center justify-center opacity-0 transition-opacity group-hover/location-list:opacity-100">
          <ChevronDownIcon className="size-5 -rotate-90" />
        </div>
      )}
      {isSelected && (
        <div className="flex min-h-[25px] min-w-[25px] items-center justify-center rounded-full bg-primary">
          <CheckIcon className="size-3 text-white" />
        </div>
      )}
    </li>
  )
}

export default DropdownLocationListItem
